import { generateTokenFn } from './tokens';
export var focus = {
  styles: function styles(_ref) {
    var target = _ref.target,
        shadow = _ref.shadow;
    return {
      outline: 'none',
      boxShadow: generateTokenFn({
        target: target,
        tokenKey: 'shadow',
        type: 'shadow',
        fallback: shadow,
        base: function base(_ref2) {
          var token = _ref2.token;
          return token('shadow.focus');
        }
      })
    };
  },
  tokens: function tokens(_ref3) {
    var target = _ref3.target,
        shadow = _ref3.shadow;
    return {
      shadow: generateTokenFn({
        target: target,
        tokenKey: 'shadow',
        type: 'shadow',
        fallback: shadow,
        base: function base(_ref4) {
          var token = _ref4.token;
          return token('shadow.focus');
        }
      })
    };
  }
};